import { render, staticRenderFns } from "./ShowFormEvaluation.vue?vue&type=template&id=2b2895e7&"
import script from "./ShowFormEvaluation.vue?vue&type=script&lang=js&"
export * from "./ShowFormEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports